import React from "react";

import { Link } from "react-router-dom";

interface ICategoryHashtagProps {
    category: string;
    taggedFeed: (ev: React.MouseEventHandler, category: string) => void;
}

export default function CategoryHashtag ({ category, taggedFeed }: ICategoryHashtagProps) {
return (
  <span
    className="float-left mr-1 py-1 px-2 shadow-md no-underline bg-zinc-800 text-white font-sans font-semibold text-sm border-slate-400 btn-primary hover:text-white hover:bg-slate-500 active:shadow-none mr-2"
    style={{
      fontFamily: "Courier Prime",
    }}
  >
    <Link to={`/tags/${category}`}>#{category}</Link><br />
  </span>
);

}